<template>
  <div class="InsuranceCardComponent">
    <div class="insurance-header">
      <h2 class="insurance-title">{{ insured }}</h2>
      <span class="insurance-date">{{ birthDate }}</span>
    </div>

    <div class="insurance-body">
      <h3 class="insurance-subtitle">
        {{ t('hiring.common.insurance-card.additional-coverages') }}
      </h3>

      <ul class="insurance-list">
        <li
          v-for="(coverage, index) in coverages"
          :key="index"
        >
          <span v-if="coverage.checked">
            {{ coverage.label }}
          </span>

          <span v-if="coverage.checked && coverage.value">
            - {{ addCommas(coverage.value) }}{{ coverage.currency }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { CoverageOptionsInterface } from '@/modules/core/models/types'
import { addCommas } from '@/utils/textUtils'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
  insured: String,
  birthDate: String,
  coverages: Array as () => CoverageOptionsInterface[]
})
</script>

<style lang="scss" scoped>
.InsuranceCardComponent {
  margin-bottom: $spacing-2xl;

  .insurance-header {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: $gap-6;
    margin-bottom: $spacing-l;
  }

  .insurance-title {
    font-size: $font-size-xs;
    font-weight: $font-weight-700;
    line-height: $line-height-17;
    color: $color-primary-dark;
    margin: 0;
    border: 1px solid black;
    padding: $spacing-2 $spacing-10;
    border-radius: $b-radius-16;
    border-color: $color-blue-200;
    background-color: $color-primary-lighter;
  }

  .insurance-date {
    font-size: $font-size-s;
    line-height: $line-height-26;
    font-weight: $font-weight-400;
    color: $color-neutral-dark;
  }

  .insurance-subtitle {
    font-size: $font-size-s;
    line-height: 14px;
    font-weight: $font-weight-400;
    color: $color-neutral;
    margin-bottom: $spacing-m;
  }

  .insurance-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .insurance-list li {
    font-size: $font-size-m;
    line-height: $size-16;
    font-weight: $font-weight-400;
    color: $color-neutral-dark;
    margin-bottom: $spacing-m;
  }
}
</style>
